import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import React from "react";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";
import { UnitRentButton } from "@/components/units/action/unitRentButton";
import { UnitReserveButton } from "@/components/units/action/unitReserveButton";
import { UnitQuoteButton } from "@/components/units/action/unitQuoteButton";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitItemContext } from "@/hooks/useUnitItemContext";

export const UnitCheckout: React.FC = () => {
    const unitJourneyContext = useUnitJourneyContext();
    const { disableRental, disableReservation, disableSoftReservation } = useDisplayOptionContext();

    const { selectedUnitId } = unitJourneyContext;

    const { unitGroup } = useUnitItemContext();
    const reservationWindowAllowed = React.useMemo(() => {
        return unitGroup.reservation_allowed;
    }, [unitGroup]);

    const stableUnitId = React.useMemo(() => selectedUnitId, [selectedUnitId]);

    return (
        <div className="unit-checkout tw:flex-1 tw:overflow-y-auto tw:py-4">
            {!disableRental && (
                <Card>
                    <CardHeader>
                        <CardTitle>Rent Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in as soon as today.</li>
                            <li>Simple online rental process.</li>
                        </ul>
                        <UnitRentButton unitId={stableUnitId} />
                    </CardContent>
                </Card>
            )}
            {!disableReservation && reservationWindowAllowed && (
                <Card>
                    <CardHeader>
                        <CardTitle>Reserve Your Unit</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <ul className="tw:list-disc">
                            <li>Move in when you're ready.</li>
                            <li>No obligation to rent.</li>
                        </ul>
                        <UnitReserveButton unitId={stableUnitId} />
                    </CardContent>
                </Card>
            )}
            {!disableSoftReservation && (<Card>
                <CardHeader>
                    <CardTitle>Get a Quote</CardTitle>
                    <CardDescription>Secure your rate.</CardDescription>
                </CardHeader>
                <CardContent>
                    <div>
                        Quote and special can expire after 7 days. Can be
                        changed to rental or reservation.
                    </div>
                    <UnitQuoteButton unitId={stableUnitId} />
                </CardContent>
            </Card>)}
        </div>
    );
};
